export default{
    registerError(context,payload){
        const {errors} = payload;
        context.commit('setErrors',errors);
    },
    registerMessage(context,payload){
        const {message} = payload;
        context.commit('setMessages',message);
    }
}